<template>
  <button
    class="btn btn-xs btn-success"
    type="button"
    data-toggle="modal"
    data-target="#upgrade_testdrive_modal"
    @click="selectSubscriber"
  >
    Upgrade
  </button>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";

export default {
  name: "UpgradeTestDriveButton",
  store,
  props: {
    subscriberId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(["testdrive"]),
  },
  methods: {
    selectSubscriber(event, subscriberId = this.subscriberId) {
      this.$store.commit("testdrive/SET_SELECTED_SUBSCRIBER_ID", subscriberId);
    },
  },
};
</script>

<style scoped></style>
